<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CN" id="_idParaDest-5"><span class="CharOverride-10">To my agent, David Gernert.<br/>This is the tenth DeMarco novel and were it not for David, <br/>the first one would never have been published. Words cannot <br/>express how much I appreciate all he’s done for me.</span></p>
<p class="PN"><span class="CharOverride-11">House Rivals</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook_4345-4.vue?50a0bbc1